import React from 'react';
import Config from 'config';

import { getItem, setItem } from './lib/local-storage';

const moduleDefaultExport = module => module.default || module;

export default function asyncRoute(getComponent) {
  return class AsyncRoute extends React.Component {
    static Component = null

    state = {
      Component: AsyncRoute.Component
    }

    componentDidMount() {
      if (getItem('currentURL') !== `${Config.api.host}${this.props.location.pathname}`) {
        setItem('referringURL', getItem('currentURL'));
        setItem('currentURL', `${Config.api.host}${this.props.location.pathname}`);
      }
    }

    componentWillMount() {
      this.unlisten = this.props.history.listen((location, _action) => {
        if (getItem('currentURL') !== `${Config.api.host}${location.pathname}`) {
          setItem('referringURL', getItem('currentURL'));
          setItem('currentURL', `${Config.api.host}${location.pathname}`);
        }
      });
      if (!this.state.Component) {
        getComponent()
          .then(moduleDefaultExport)
          .then(Component => {
            AsyncRoute.Component = Component;
            this.setState({ Component });
          });
      }
    }

    componentWillUnmount() {
      this.unlisten();
    }

    render() {
      const { Component } = this.state;
      return Component ? <Component {...this.props} /> : null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/async-route.js